if (document.querySelectorAll(".annual-reports__select-option")) {
  const customSelect = document.querySelector(".annual-reports__custom-select");

  document
    .querySelectorAll(".annual-reports__select-option")
    .forEach((option) => {
      option.addEventListener("click", function () {
        const selectedValue = this.textContent.trim();
        const dataWrappers = document.querySelectorAll(
          ".annual-reports__data-wrapper"
        );
        const downloadButtons = document.querySelectorAll(
          ".annual-reports__download-button"
        );
        let target = selectedValue;

        document.querySelector(".annual-reports__selected-option").textContent =
          selectedValue;

        dataWrappers.forEach(function (item) {
          if (item.classList.contains("active")) {
            item.classList.remove("active");
          }

          if (item.id === target) {
            item.classList.add("active");
          }
        });

        downloadButtons.forEach(function (item) {
          if (item.classList.contains("active")) {
            item.classList.remove("active");
          }

          if (item.id === target) {
            item.classList.add("active");
          }
        });
      });
    });

  customSelect.addEventListener("click", () => {
    if (customSelect.classList.contains("options-active")) {
      customSelect.classList.remove("options-active");
    } else {
      customSelect.classList.add("options-active");
    }
  });
}
